// extracted by mini-css-extract-plugin
export default {"container":"M_-z","productName":"N_-z","price":"O_-z","dimensions":"P_-z"};